import { List, ListItem, OrderedList, Table, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { type MDXRemoteProps } from "next-mdx-remote";
import { Link } from "ui/link";
import React from "react";

export const components: MDXRemoteProps["components"] = {
  h2: ({ children }) => (
    <Text as="h2" textStyle="article.h3">
      {children}
    </Text>
  ),
  strong: ({ children }) => (
    <Text as="strong" fontWeight="semibold">
      {children}
    </Text>
  ),
  ul: ({ children }) => (
    <List textStyle="article.list" listStyleType="disc">
      {children}
    </List>
  ),
  ol: ({ children }) => (
    <OrderedList textStyle="article.list" listStyleType="auto">
      {children}
    </OrderedList>
  ),
  li: ({ children }) => <ListItem textStyle="article.listItem">{children}</ListItem>,
  a: ({ children, href }) => (
    <Link href={href} variant="inlineDark">
      {children}
    </Link>
  ),
  p: ({ children }) => <Text textStyle="article.p">{children}</Text>,
  table: ({ children }) => (
    <Table maxW="400px" mx="auto">
      {children}
    </Table>
  ),
  thead: ({ children }) => <Thead>{children}</Thead>,
  th: ({ children }) => (
    <Th color="brand.text.light" textTransform="none" fontSize="sm" fontFamily="inter">
      {children}
    </Th>
  ),
  tr: ({ children }) => <Tr>{children}</Tr>,
  td: ({ children }) => <Td fontSize="sm">{children}</Td>,
};
